import React, { Component } from 'react';
import DesktopLayerPopup from '../../common/DesktopLayerPopup';

import { service } from '../config';
import { CheckBox } from '../../../library/CheckBox';

class Download extends Component {
  constructor(props) {
    super(props);

    const { item } = this.props;
    const contentFiles = item?.data?.contentFiles ?? [];

    this.debounce = this.debounce.bind(this);
    this.execDownloadFiles = this.execDownloadFiles.bind(this);

    this.state = {
      selectedList: new Array(contentFiles.length).fill(false),
      showError: false,
    };
  }

  debounce(func) {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => func(), 500);
  }

  onClose(e) {
    e.preventDefault();
    const { layerKey } = this.props;

    DesktopLayerPopup.hide(layerKey);
  }

  async onClickDownloadSelected(e) {
    e.preventDefault();

    const { selectedList } = this.state;
    const { item } = this.props;

    const contentFiles = item?.data?.contentFiles ?? [];
    const selectedFiles = contentFiles.reduce((acc, cur, idx) => {
      if (cur?.filePath && selectedList[idx]) {
        acc.push(cur);
      }
      return acc;
    }, []);

    if (selectedFiles.length === 0) {
      return this.setState({ showError: true });
    }
    this.setState({ showError: false });

    await this.execDownloadFiles(item, selectedFiles);
  }

  async onClickDownloadAll(e) {
    e.preventDefault();

    const { item } = this.props;
    const contentFiles = item?.data?.contentFiles ?? [];
    const entireFilePath = item?.data?.entireZipFile;

    if (entireFilePath) {
      const files = contentFiles.reduce((acc, cur) => {
        if (cur?.filePath) {
          acc.push(cur);
        }
        return acc;
      }, []);

      const isDownloadable = await service.checkAllDownloadable([
        { filePath: entireFilePath },
      ]);
      if (isDownloadable) {
        const fileName = entireFilePath.split('/').pop();
        await service.downloadWithTimeout({ url: entireFilePath, fileName });

        await this.props.createDownloadLog(item, files);
      } else {
        DesktopLayerPopup.notice({
          message:
            '다운로드가 불가능합니다.<br />' + '운영자에게 문의해주세요.',
        });
      }
    } else {
      return DesktopLayerPopup.notice({
        message: '다운로드가 불가능합니다.<br />' + '운영자에게 문의해주세요.',
      });
    }
  }

  async onClickDownload(e, file) {
    e.preventDefault();

    const { item } = this.props;

    await this.execDownloadFiles(item, [file]);
  }

  onChangeCheckList(e, idx) {
    e.stopPropagation();
    const { selectedList } = this.state;

    selectedList[idx] = !selectedList[idx];

    this.setState({
      selectedList,
    });
  }

  async execDownloadFiles(item, files) {
    const isDownloadable = await service.checkAllDownloadable(files);
    if (isDownloadable) {
      for (const file of files) {
        await service.downloadWithTimeout({
          url: file.filePath,
          fileName: file.title,
        });
      }
      await this.props.createDownloadLog(item, files);
    } else {
      DesktopLayerPopup.notice({
        message: '다운로드가 불가능합니다.<br />' + '운영자에게 문의해주세요.',
      });
    }
  }

  renderHeader() {
    return (
      <div className="reference-room-header">
        <div>이름</div>
        <div>내용</div>
        <div>다운로드</div>
      </div>
    );
  }

  renderTitle() {
    const { item } = this.props;

    const title = item?.data?.contentTitle ?? '';

    return <div className="reference-room-download-title">{title}</div>;
  }

  renderContents() {
    return (
      <div className="contents-container">
        {this.renderTitle()}
        {this.renderItems()}
      </div>
    );
  }

  renderItems() {
    const { item } = this.props;
    const { selectedList } = this.state;

    const itemList = item?.data?.contentFiles ?? [];

    return (
      <div className="reference-room-download-item-container">
        {itemList.map((item, idx) => {
          return (
            <div className="reference-room-download-item" key={idx}>
              <div className="item-title">
                <CheckBox
                  id={`item-${idx}`}
                  name={`item-${idx}`}
                  checked={!!selectedList[idx]}
                  onChange={(e) => this.onChangeCheckList(e, idx)}
                />
                <label htmlFor={`item-${idx}`}>{item.title}</label>
              </div>
              <div
                className="item-download"
                id="reference-room-modal-download"
                onClick={(e) => this.onClickDownload(e, item)}
              >
                <img
                  src="https://us.wink.co.kr/pc/1.1.0/reference_room/download.png"
                  alt=""
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderButtons() {
    return (
      <div className="download-button-container">
        {this.renderDownloadCheckedButton()}
        {this.renderDownloadAllButton()}
        {this.renderError()}
      </div>
    );
  }

  renderDownloadCheckedButton() {
    return (
      <div
        onClick={(e) =>
          this.debounce(this.onClickDownloadSelected.bind(this, e))
        }
        id="reference-room-modal-download-selected"
      >
        <img
          src="https://us.wink.co.kr/pc/1.1.0/reference_room/download_select.png"
          alt=""
        />
      </div>
    );
  }

  renderDownloadAllButton() {
    return (
      <div
        onClick={(e) => this.debounce(this.onClickDownloadAll.bind(this, e))}
        id="reference-room-modal-download-all"
      >
        <img
          src="https://us.wink.co.kr/pc/1.1.0/reference_room/download_all.png"
          alt=""
        />
      </div>
    );
  }

  renderCloseButton() {
    return (
      <button className="close" onClick={this.onClose.bind(this)}>
        팝업 닫기
      </button>
    );
  }

  renderError() {
    const { showError } = this.state;

    if (!showError) {
      return null;
    }

    return (
      <div className="error-message">다운로드 할 파일을 선택해주세요.</div>
    );
  }

  render() {
    return (
      <div className="layer-wrap large reference-room-download">
        {this.renderCloseButton()}
        {this.renderHeader()}
        {this.renderContents()}
        {this.renderButtons()}
      </div>
    );
  }
}

export default Download;
